var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useOnResize } from '../../helper/hooks/onResize';
import RadioButton from '../../components/RadioButton';
import ButtonComponent from '../../components/ButtonComponent';
import ToggleButton from '../../components/ToggleButton';
import '../../styles/widgets/popup/diceManipulativePopup.scss';
import CustomScrollbar from '../../components/CustomScrollbar';
import globalStore from '../../store';
import { t } from 'i18next';
import MathEditor from '../../components/MathEditor';
import { DataContext } from '../../player/DataContext';
import DiceManipulative from '../DiceManipulative';
import FooterActionsButtons from './FooterActionsButtons';
import { getImageSrc } from '../../helper/imageBlobCache';
var diceTypeOptions = ['dot', 'text'];
var MAX_TEXT_WIDTH = 170;
var DiceManipulativePopup = function (props) {
    var onSubmit = props.onSubmit, _a = props.diceType, diceType = _a === void 0 ? 'dot' : _a, _b = props.lock, lock = _b === void 0 ? { positioning: false, editing: false } : _b, _c = props.faces, faces = _c === void 0 ? [] : _c, onCancel = props.onCancel, _d = props.activeFaceIndex, activeFaceIndex = _d === void 0 ? -1 : _d, _e = props.color, color = _e === void 0 ? 'WHITE' : _e;
    var _g = useContext(DataContext), setSelectedTool = _g.setSelectedTool, selectedTool = _g.selectedTool;
    var playerIconZoom = globalStore.useStoreState(function (state) { return state.playerStore; }).playerIconZoom;
    var _h = useState(diceType), inputType = _h[0], setInputType = _h[1];
    var _j = useState(1), zoomLevel = _j[0], setZoomLevel = _j[1];
    var popupRef = useRef(null);
    var _k = useState(function () {
        var _a, _b;
        var base = Array.from({ length: 6 }, function () { return [{ type: 'text', value: '' }]; });
        if (faces && Array.isArray(faces) && diceType !== 'dot') {
            for (var i = 0; i < 6; i++) {
                base[i] = (_b = (_a = faces[i]) === null || _a === void 0 ? void 0 : _a.frontImage) !== null && _b !== void 0 ? _b : [{ type: 'text', value: '' }];
            }
        }
        return base;
    }), texts = _k[0], setTexts = _k[1];
    // const base = Array(6).fill([
    //   {
    //     type: 'text',
    //     value: '',
    //   },
    // ]);
    //   if (faces && Array.isArray(faces) && diceType !== 'dot') {
    //     for (let i = 0; i < 6; i++) {
    //       base[i] = faces[i]?.frontImage ?? [
    //         {
    //           type: 'text',
    //           value: '',
    //         },
    //       ];
    //     }
    //   }
    //   return base;
    // });
    var _l = useState(0), rollValue = _l[0], setRollValue = _l[1];
    var _m = useState(function () {
        if (inputType === 'dot') {
            // DOT MODE → disable all toggles
            return Array(6).fill(false);
        }
        else {
            var _activeState = faces.length === 0
                ? __spreadArray([true, true], Array(4).fill(false), true) : Array.from({ length: 6 }, function (_, i) { return Boolean(faces === null || faces === void 0 ? void 0 : faces[i]); });
            return _activeState;
        }
    }), activeStates = _m[0], setActiveStates = _m[1];
    var _o = useState(false), doneError = _o[0], setDoneError = _o[1];
    var _p = useState(true), disableDoneButton = _p[0], setDisableDoneButton = _p[1];
    var _q = useState(lock.positioning), lockPosition = _q[0], setLockPosition = _q[1];
    var _r = useState(activeFaceIndex), currentFace = _r[0], setCurrentFace = _r[1];
    var _s = useState(-1), activeMathInput = _s[0], setActiveMathInput = _s[1];
    var diceTypeOptionsText = [t('text.dot'), t('text.textNumbers')];
    var _t = globalStore.useStoreState(function (store) { return store.jsonDataStore; }), btnConfig = _t.btnConfig, bottomToolConfig = _t.bottomToolConfig;
    var mathEditorRefs = useRef([]);
    var dicePreviewContainerRef = useRef(null);
    // Remember the active-state the user had while in text mode, so switching
    // away to 'dot' and back doesn't wipe their toggles.
    var lastTextActiveStatesRef = useRef(null);
    var handleDone = function () {
        var isSequentialTrue = function (arr) {
            var foundFalseAfterTrue = false;
            for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
                var value = arr_1[_i];
                if (value === false && !foundFalseAfterTrue) {
                    foundFalseAfterTrue = true;
                }
                if (value === true && foundFalseAfterTrue) {
                    return false; // true found after a gap
                }
            }
            return true;
        };
        if (!isSequentialTrue(activeStates)) {
            setDoneError(true);
            return;
        }
        var _faces = inputType === 'dot'
            ? Array.from({ length: 6 }, function (_, i) { return (__assign(__assign({}, ((faces === null || faces === void 0 ? void 0 : faces[i]) || {})), { frontImage: [
                    {
                        type: 'text',
                        value: String(i + 1),
                    },
                ] })); })
            : texts
                .map(function (txt, i) { return (__assign(__assign({}, ((faces === null || faces === void 0 ? void 0 : faces[i]) || {})), { frontImage: txt })); })
                .filter(function (_f, i) { return activeStates[i]; }); // only active in text mode
        var data = {
            diceType: inputType,
            lock: { positioning: lockPosition, editing: lock.editing },
            faces: _faces,
        };
        // console.log(
        //   {
        //     type: 'dice',
        //     data: {
        //       diceType: inputType,
        //       diceFace: data,
        //       frontFaceIndex: 0,
        //     },
        //   },
        //   'onSubmit'
        // );
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(data);
    };
    // const handleTextChange = (index: number, value: string) => {
    //   const sanitizedValue = value.replace(/\s+/g, '').slice(0, 7);
    //   const newTexts = [...texts];
    //   newTexts[index] = sanitizedValue;
    //   setTexts(newTexts);
    //   setDoneError(false);
    // };
    var handleTextChange = function (content, type, index, additionalData) {
        var idx = Number(index);
        // if (additionalData?.width < MAX_TEXT_WIDTH) {
        var sanitizedValue = function (val) {
            if (!val)
                return '';
            return val.replace(/<br\s*\/?>/gi, '');
        };
        setTexts(function (prev) {
            var newState = __spreadArray([], prev, true);
            if (typeof content === 'string') {
                newState[idx] = [{ type: 'text', value: sanitizedValue(content) }];
            }
            else {
                newState[idx] = content.map(function (item) { return (__assign(__assign({}, item), { value: sanitizedValue(item.value) })); });
            }
            return __spreadArray([], newState, true);
        });
        // } else {
        //   setTexts(prev => {
        //     const newState = [...prev];
        //     newState[idx] = [{ type: 'text', value: '' }];
        //     return [...newState];
        //   });
        // }
    };
    /**
     * CORRECT HANDLER: Receives the string state ('on' or 'off') and converts it to boolean.
     */
    var handleToggleChange = function (index, newState) {
        if (inputType === diceTypeOptions[0])
            return;
        var newActiveStates = __spreadArray([], activeStates, true);
        var isOn = newState === 'enable';
        newActiveStates[index] = isOn;
        // setActiveMathInput(prev => (prev === index && !isOn ? -1 : prev));
        // If turned OFF → disable all next toggles
        // if (!isOn) {
        //   for (let i = index + 1; i < newActiveStates.length; i++) {
        //     newActiveStates[i] = false;
        //   }
        // }
        setActiveStates(newActiveStates);
        // Keep the text-mode memory in sync so a dot→text round trip preserves it.
        lastTextActiveStatesRef.current = newActiveStates;
        setDoneError(false);
    };
    var diceShadowImageSrc = './assets/images/manipulative/dice/diceShadow.svg';
    var diceFaces = {
        1: {
            blue: './assets/images/manipulative/dice/dice_1.svg',
            white: './assets/images/manipulative/dice/dice_1_white.svg',
        },
        2: {
            blue: './assets/images/manipulative/dice/dice_2.svg',
            white: './assets/images/manipulative/dice/dice_2_white.svg',
        },
        3: {
            blue: './assets/images/manipulative/dice/dice_3.svg',
            white: './assets/images/manipulative/dice/dice_3_white.svg',
        },
        4: {
            blue: './assets/images/manipulative/dice/dice_4.svg',
            white: './assets/images/manipulative/dice/dice_4_white.svg',
        },
        5: {
            blue: './assets/images/manipulative/dice/dice_5.svg',
            white: './assets/images/manipulative/dice/dice_5_white.svg',
        },
        6: {
            blue: './assets/images/manipulative/dice/dice_6.svg',
            white: './assets/images/manipulative/dice/dice_6_white.svg',
        },
    };
    var colorArr = {
        white: '#ffffff',
        blue: '#293273',
    };
    var diceSpriteSheet = {
        RED: {
            path: './assets/images/manipulative/dice/diceSpritesheet_red.png',
            textColor: 'white',
        },
        BLUE: {
            path: './assets/images/manipulative/dice/diceSpritesheet_blue.png',
            textColor: 'blue',
        },
        GREEN: {
            path: './assets/images/manipulative/dice/diceSpritesheet_green.png',
            textColor: 'blue',
        },
        // pending assign new image path
        ORANGE: {
            path: './assets/images/manipulative/dice/diceSpritesheet_orange.png',
            textColor: 'blue',
        },
        YELLOW: {
            path: './assets/images/manipulative/dice/diceSpritesheet_yellow.png',
            textColor: 'blue',
        },
        BLACK: {
            path: './assets/images/manipulative/dice/diceSpritesheet_blue.png',
            textColor: 'blue',
        },
        BROWN: {
            path: './assets/images/manipulative/dice/diceSpritesheet_brown.png',
            textColor: 'blue',
        },
        PURPLE: {
            path: './assets/images/manipulative/dice/diceSpritesheet_purple.png',
            textColor: 'blue',
        },
        WHITE: {
            path: './assets/images/manipulative/dice/diceSpritesheet_white.png',
            textColor: 'blue',
        },
        GRAY: {
            path: './assets/images/manipulative/dice/diceSpritesheet_gray.png',
            textColor: 'blue',
        },
        DARK_NAVY_BLUE: {
            path: './assets/images/manipulative/dice/diceSpritesheet_blue.png',
            textColor: 'white',
        },
    };
    var isDotDice = inputType === diceTypeOptions[0];
    var renderDicePreview = useMemo(function () {
        var activeIndex = currentFace === -1 ? activeStates.findIndex(function (state) { return state; }) : currentFace - 1;
        var displayText = activeIndex !== -1 && texts[activeIndex] && texts[activeIndex].length > 1
            ? texts[activeIndex]
            : '';
        var filteredTexts = texts
            .map(function (t, i) { return i; })
            .filter(function (index) {
            var _a, _b;
            return (((_b = (_a = mathEditorRefs.current[index]) === null || _a === void 0 ? void 0 : _a.getTotalCharacterCount(true)) !== null && _b !== void 0 ? _b : 0) > 0 &&
                activeStates[index]);
        });
        return (_jsx(DiceManipulative, { id: "dicePreview", type: "dice", diceType: inputType, faces: inputType === 'dot'
                ? Object.values(diceFaces).flat()
                : texts
                    .map(function (t) { return ({ frontImage: t }); })
                    .filter(function (_f, i) { return activeStates[i]; }), activeFaceIndex: activeIndex === -1 ? 5 : filteredTexts[0] + 1, color: color, center: { x: 0, y: 0 }, dimensions: { width: 128 * zoomLevel, height: 117 * zoomLevel }, scale: zoomLevel, 
            // scale={zoomLevel}
            // dimensions={{ width: 128 * zoomLevel, height: 117 * zoomLevel }}
            lock: { positioning: false, editing: false }, disabled: true, diceShadowImageSrc: diceShadowImageSrc, 
            // fontSizeOverride={inputType === 'dot' ? undefined : previewFontSize}
            isWhiteBoard: false }));
        return (_jsxs("div", { id: 'diceWithShadow', className: "diceWithShadow", tabIndex: -1, "aria-label": "Dice preview. ".concat(isDotDice
                ? "Face ".concat(currentFace === -1 ? 5 : currentFace)
                : activeIndex !== -1
                    ? "Face ".concat(activeIndex + 1)
                    : 'No active face', "\n        \n        "), children: [_jsx("img", { className: "diceShadowImg", src: getImageSrc(diceShadowImageSrc), alt: "", draggable: false, "aria-hidden": true }), _jsxs("div", { id: 'dice', className: "diceDim ", children: [_jsx("div", { className: "diceSprite", style: {
                                backgroundImage: "url(".concat(diceSpriteSheet[color].path, ")"),
                            } }), isDotDice && (_jsx("img", { className: "diceDot", src: getImageSrc(diceFaces[currentFace === -1 ? 5 : currentFace][diceSpriteSheet[color].textColor]), alt: "", draggable: false, "aria-hidden": true })), !isDotDice && (_jsx("div", { className: "diceData", style: { color: "".concat(colorArr[diceSpriteSheet[color].textColor]) }, "aria-hidden": true, children: _jsx(MathEditor, { data: {
                                    type: 'data',
                                    data: {
                                        text: displayText,
                                        color: "".concat(colorArr[diceSpriteSheet[color].textColor]),
                                        alignment: 'center',
                                    },
                                }, className: "displayDice", isTextUpdate: false, idPreffix: "dicePopupImage", index: 0, keypadButtons: bottomToolConfig.mathKeypad, bottomBtns: bottomToolConfig.mathKeypadBottom, disableTransform: true, isManipulative: true, viewonly: true, blockNewLine: true }) }))] })] }));
    }, [inputType, currentFace, activeStates, texts, faces, color, activeMathInput]);
    var isToggleEnabled = function (index) {
        if (inputType === 'dot')
            return false; // Dot mode → all disabled
        return true;
    };
    // Read --dice-zoom immediately on mount so the preview renders at the correct size
    useLayoutEffect(function () {
        if (popupRef.current) {
            var iconSize = getComputedStyle(popupRef.current).getPropertyValue('--dice-zoom');
            if (iconSize) {
                setZoomLevel(Math.max(Number(iconSize), 1));
            }
        }
    }, []);
    // Keep listening for window resizes that change the media-query breakpoint
    useOnResize(function () {
        var el = popupRef.current || document.getElementsByClassName('diceManipulative')[0];
        if (!el)
            return;
        var iconSize = getComputedStyle(el).getPropertyValue('--dice-zoom');
        setZoomLevel(Math.max(Number(iconSize), 1));
    }, 100);
    useEffect(function () {
        if (inputType === 'dot')
            return;
        setTimeout(function () {
            var isFocused = false;
            texts.forEach(function (t, i) {
                var _a;
                if (t.length <= 1 && !isFocused) {
                    isFocused = true;
                    (_a = mathEditorRefs.current[i]) === null || _a === void 0 ? void 0 : _a.focus();
                }
            });
            // mathEditorRefs.current[0]?.focus();
        }, 0);
    }, [inputType]);
    // useEffect(() => {
    //   const isTextMode = inputType !== diceTypeOptions[0];
    //   if (!isTextMode) {
    //     setDisableDoneButton(false);
    //     return;
    //   }
    //   const activeCount = activeStates.filter(Boolean).length;
    //   const hasEnoughActive = activeCount >= 2;
    //   if (!hasEnoughActive) {
    //     setDisableDoneButton(true);
    //     return;
    //   }
    //   console.log(texts, activeStates, '$%^$%^');
    //   let _checkCondition = true;
    //   activeStates.forEach((_as, _index) => {
    //     if (_as) {
    //       const _check = !texts[_index].every(
    //         _t => (_t.type === 'text' || _t.type === 'math') && _t.value === ''
    //       );
    //       _checkCondition = _checkCondition && _check;
    //       console.log(_check, '$%^$%^');
    //     }
    //   });
    //   const allActiveTextsFilled = isTextMode ? _checkCondition : true;
    // // //   // const allActiveTextsFilled = texts.every((txt, index) => {
    // // //   //   console.log(txt, !activeStates[index], index, '$%^$%^');
    // // //   //   if (!activeStates[index]) return true; // ignore inactive
    // // //   //   return txt.length > 0 && txt.every(t => t.value.trim() !== '');
    // // //   // });
    //   setDisableDoneButton(!allActiveTextsFilled);
    // }, [inputType, activeStates, texts]);
    // useEffect(() => {
    //   const isTextMode = inputType !== 'dot';
    //   if(!isTextMode) {
    //     setDisableDoneButton(false);
    //     return;
    //   }
    //   const activeCount = activeStates.filter(Boolean).length;
    //   const hasEnoughActive = activeCount >= 2;
    //   if(!hasEnoughActive) {
    //     setDisableDoneButton(true);
    //     return;
    //   }
    //   const allActiveTextsFilled = activeStates.every((isActive, index) => {
    //     if (!isActive)
    //       return true;
    //     const faceContent = texts[index];
    //     if (!faceContent || !Array.isArray(faceContent))
    //       return false;
    //     const hasContent = faceContent.some(
    //       item => item.value && item.value.trim() !== ''
    //     );
    //     return hasContent;
    //   });
    //   setDisableDoneButton(!allActiveTextsFilled);
    // }, [inputType, activeStates, texts]);
    useEffect(function () {
        if (inputType === 'dot') {
            setDisableDoneButton(false);
            return;
        }
        var activeCount = activeStates.filter(Boolean).length;
        var hasMinimumFaces = activeCount >= 2;
        var allActiveFacesFilled = activeStates.every(function (isActive, index) {
            var _a;
            if (!isActive)
                return true;
            var faceContent = texts[index];
            if (!faceContent || !Array.isArray(faceContent))
                return false;
            // const textValue = faceContent
            //   .map(t => t.value)
            //   .join('')
            //   .trim();
            var count = (_a = mathEditorRefs.current[index]) === null || _a === void 0 ? void 0 : _a.getTotalCharacterCount(true);
            return (count !== null && count !== void 0 ? count : 0) > 0;
        });
        setDisableDoneButton(!hasMinimumFaces || !allActiveFacesFilled);
    }, [texts, activeStates, inputType]);
    // useEffect(() => {
    //   console.log(inputType, 'inputType');
    //   if (inputType === 'dot' || faces.length === 0) {
    //     // DOT MODE → disable all toggles
    //     setActiveStates(Array(6).fill(false));
    //     setDisableDoneButton(false);
    //   } else {
    //     const _activeState =
    //       faces.length === 0
    //         ? Array(6).fill(true)
    //         : Array.from({ length: 6 }, (_, i) => Boolean(faces?.[i]));
    //     setActiveStates(_activeState);
    //   }
    // }, [inputType]);
    useEffect(function () {
        var _a;
        if (inputType === 'dot') {
            // DOT MODE → remember current text-mode activeStates (if any), then
            // disable all toggles.
            setActiveStates(function (prev) {
                if (prev.some(Boolean))
                    lastTextActiveStatesRef.current = prev;
                return Array(6).fill(false);
            });
            setDisableDoneButton(false);
        }
        else {
            // TEXT MODE → restore last text-mode state if the user has been here
            // before, otherwise default to first 3 inputs enabled.
            setActiveStates((_a = lastTextActiveStatesRef.current) !== null && _a !== void 0 ? _a : __spreadArray([true, true], Array(4).fill(false), true));
        }
        setDoneError(false);
        // setTexts(
        //   Array(6).fill([
        //     {
        //       type: 'text',
        //       value: '',
        //     },
        //   ])
        // );
        // setCurrentFace(-1);
        // setActiveMathInput(-1);
    }, [inputType]);
    useEffect(function () {
        setInputType(diceType);
        if (diceType === 'dot' || faces.length === 0) {
            // DOT MODE → disable all toggles
            setActiveStates(Array(6).fill(false));
            setDisableDoneButton(false);
        }
        else {
            var _activeState = faces.length === 0
                ? __spreadArray([true, true], Array(4).fill(false), true) : Array.from({ length: 6 }, function (_, i) { return Boolean(faces === null || faces === void 0 ? void 0 : faces[i]); });
            setActiveStates(_activeState);
        }
    }, [diceType]);
    var addMathText = function (index) {
        setSelectedTool(["diceMathText_".concat(index)]);
        // Focus the editor first, then insert math.
        // On iPad, tapping the button blurs the contentEditable and clears the
        // selection, so we must re-focus before inserting — otherwise the cursor
        // jumps to the start and the math field is appended at position 0.
        setTimeout(function () {
            var _a;
            (_a = mathEditorRefs.current[index]) === null || _a === void 0 ? void 0 : _a.focus();
            setTimeout(function () {
                var _a;
                (_a = mathEditorRefs.current[index]) === null || _a === void 0 ? void 0 : _a.insertMath();
                // Focus first keypad button after keypad renders
                setTimeout(function () {
                    var keypad = document.querySelector('.keypadWrapper .keypadBtn');
                    keypad === null || keypad === void 0 ? void 0 : keypad.focus();
                }, 100);
            }, 50);
        }, 10);
    };
    // useEffect(() => {
    //   const _selectedMathText = selectedTool.filter(_s => _s.includes('diceMathText_'));
    //   if (_selectedMathText.length > 0) {
    //     const _selectedKey = +_selectedMathText[0].split('_')[1];
    //     setActiveMathInput(_selectedKey);
    //   } else {
    //     setActiveMathInput(-1);
    //   }
    // }, [selectedTool]);
    return (_jsx("div", { ref: popupRef, className: "diceManipulative", "data-mfdeselect": "true", children: _jsxs("div", { className: "scrollbarHolder", children: [_jsxs(CustomScrollbar, { direction: "vertical", tabIndex: -1, verticalTrackAriaHidden: true, children: [_jsxs("div", { className: "diceHeaderSection", children: [_jsx("div", { className: "diceTypeSelectorWrapper", children: _jsxs("fieldset", { className: "diceTypeSelector", children: [_jsx("legend", { className: "diceTypeSelectorTitle", tabIndex: -1, children: t('text.diceType') }), _jsx("div", { className: "radioButtonGroup", children: _jsx(RadioButton, { id: "dice-type-dot-and-text", options: diceTypeOptionsText, selected: diceTypeOptions.indexOf(diceType), onChange: function (value) {
                                                        var newType = diceTypeOptions[value];
                                                        setInputType(newType);
                                                        setDoneError(false);
                                                        setCurrentFace(-1);
                                                        // setActiveMathInput(-1);
                                                        setTimeout(function () {
                                                            var _a;
                                                            var diceEl = (_a = dicePreviewContainerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[id^="diceWithShadow_"]');
                                                            diceEl === null || diceEl === void 0 ? void 0 : diceEl.focus();
                                                        }, 0);
                                                    }, 
                                                    // => {
                                                    //   setInputType(diceTypeOptions[value] as typeof inputType);
                                                    // }}
                                                    className: "radioGap" }) })] }) }), _jsx("div", { className: "dicePreviewIcon", ref: dicePreviewContainerRef, style: { position: 'relative' }, children: renderDicePreview })] }), _jsx("div", { className: "diceInstruction ".concat(inputType !== diceTypeOptions[0] ? 'visible' : ''), "aria-hidden": isDotDice ? true : undefined, children: doneError ? (_jsx("span", { role: "alert", children: t('text.diceFaceSequentialError') })) : (t('text.diceInstruction')) }), _jsx("div", { className: "diceFacesSection", "aria-hidden": isDotDice ? true : undefined, children: _jsx("div", { className: "diceFacesGrid", children: Array.from({ length: 6 }, function (_, index) {
                                    var _a, _b, _c, _d;
                                    var faceId = index + 1;
                                    var inputId = "face-".concat(faceId, "-input");
                                    var toggleId = "face-".concat(faceId, "-toggle");
                                    return (_jsxs("fieldset", { className: "diceFaceInputWrapper", "aria-disabled": inputType === diceTypeOptions[0] ? true : undefined, children: [_jsxs("legend", { 
                                                // htmlFor={`face-${index + 1}_input`}
                                                className: "diceFaceLabel ".concat(diceTypeOptions[0] === inputType ? 'disabled' : ''), children: [t('text.face'), " ", index + 1] }), _jsx(MathEditor, { data: {
                                                    type: 'data',
                                                    data: {
                                                        text: texts[index],
                                                        color: '#274e9f',
                                                        alignment: 'center',
                                                    },
                                                }, color: "#274e9f", className: "diceFaceInputField ".concat(inputType === diceTypeOptions[0] || !activeStates[index]
                                                    ? 'mathEditor_disable'
                                                    : ''), placeHolder: '', isTextUpdate: false, index: index, idPreffix: 'diceMathText', cb: handleTextChange, keypadButtons: bottomToolConfig.mathKeypad, bottomBtns: bottomToolConfig.mathKeypadBottom, disableTransform: true, setActiveMathText: setActiveMathInput, viewonly: inputType === diceTypeOptions[0] || !activeStates[index], throwChangeOnBlur: true, maxCharacters: 7, ref: function (el) {
                                                    if (el) {
                                                        mathEditorRefs.current[index] = el;
                                                    }
                                                }, isManipulative: true, scrollIntoViewOnFocus: true, blockNewLine: true }), _jsxs("div", { className: "toggleSwitchWrapper", children: [_jsx(ButtonComponent, { type: "imageType5", imgSrc: __assign({}, btnConfig.mathtext.imgSrc), disabled: inputType === diceTypeOptions[0] ||
                                                            !activeStates[index] ||
                                                            ((_b = (_a = mathEditorRefs === null || mathEditorRefs === void 0 ? void 0 : mathEditorRefs.current) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.mathFieldInstancesCount()) === 2, defaultCSS: "mathTextBtn", clickActive: true, isActive: inputType === diceTypeOptions[0] ? false : activeMathInput === index, controlActiveFromOutside: true, clickHandler: function () {
                                                            addMathText(index);
                                                        }, showToolTip: true, direction: "top", isParentRelative: true, title: t('text.openMathKeypad'), ariaLabel: t('text.openMathKeypad'), ariaHaspopup: true, ariaExpanded: activeMathInput === index, ariaHidden: isDotDice, tabIndex: inputType === diceTypeOptions[0] ||
                                                            !activeStates[index] ||
                                                            ((_d = (_c = mathEditorRefs === null || mathEditorRefs === void 0 ? void 0 : mathEditorRefs.current) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.mathFieldInstancesCount()) === 2
                                                            ? -1
                                                            : undefined }), ![0, 1].includes(index) && (_jsx(ToggleButton, { initial: activeStates[index] ? 'enable' : 'disable', onChange: function (checked) { return handleToggleChange(index, checked); }, options: [
                                                            {
                                                                id: 'toggle1',
                                                                ariaLabel: t('text.enableFace'),
                                                                value: 'enable',
                                                            },
                                                            {
                                                                id: 'toggle2',
                                                                ariaLabel: t('text.disableFace'),
                                                                value: 'disable',
                                                            },
                                                        ], toggleType: "switch", textVisible: false, ariaLabel: t('text.enableOrDisableFace', { number: index + 1 }), className: 'toggleCSS', disabled: inputType === diceTypeOptions[0], alternateColor: true, normalCSS: "toggleNormal" }))] })] }, index));
                                }) }) })] }), _jsx(FooterActionsButtons, { disableDoneBtn: disableDoneButton || doneError, onActionBtnClick: function (type) {
                        if (type === 'done') {
                            handleDone();
                        }
                        else {
                            onCancel === null || onCancel === void 0 ? void 0 : onCancel();
                        }
                    } })] }) }));
};
export default DiceManipulativePopup;
